// Generate random number between min and max
const random = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

// Generate random percentage change
const randomChange = () => (Math.random() > 0.5 ? 1 : -1) * random(5, 30);

export const getMockDashboardData = () => ({
  user: {
    name: 'Autobahn GmbH',
    avatar: '/logos/UserLogo.png',
  },
  stats: {
    totalCustomers: {
      value: 1372902,
      change: -8,
      label: 'Asphaltmischgut bilanziert'
    },
    totalRevenue: {
      value: 47,
      change: -9,
      label: 'kg CO₂e/t Asphaltmischgut'
    },
    totalSales: {
      value: 9432902,
      change: -22,
      label: 'Prognose 2024'
    }
  },
  topProducts: [
    {
      id: 1,
      image: '/api/placeholder/40/40',
      name: 'AC 11 D SP',
      category: "Eurovia GmbH",
      stock: '- 33 %',
      sales: '53 kg CO₂e/t'
    },
    {
      id: 2,
      image: '/api/placeholder/40/40',
      name: 'AC 22 B S SG',
      category: "Heidelberg Materials",
      stock: '- 31 %',
      sales: '43 kg CO₂e/t'
    },
    {
      id: 3,
      image: '/api/placeholder/40/40',
      name: 'AC 22 T S',
      category: "Strabag SE",
      stock: '- 27 %',
      sales: '41 kg CO₂e/t'
    }
  ],
  topCountries: [
    { name: 'FDI A81', purchases: 51, amount: '7.120 t' },
    { name: 'FDI A7', purchases: 47, amount: '6.154 t' },
    { name: 'FDI A73', purchases: 45, amount: '5.458 t' },
  ],
  topCustomers: [
    { name: 'Eurovia GmbH', purchases: 51, amount: '14.190 t' },
    { name: 'Strabag SE', purchases: 47, amount: '12.436 t' },
    { name: 'Heidelberg', purchases: 55, amount: '9.221 t' },
    { name: 'Max Bögl Gruppe', purchases: 56, amount: '7.453 t' },
  ],
  recentOrders: [
    { name: 'FDI A61', purchases: 48, amount: '5.230 t' },
    { name: 'FDI A52', purchases: 53, amount: '4.897 t' },
    { name: 'FDI A44', purchases: 47, amount: '3.550 t' }
  ]
});